import { Controller } from "@hotwired/stimulus"

// The website hero's product video. Shows the poster and one big play button;
// the first press plays WITH sound (a user gesture allows it) and hands over
// to the browser's own controls. Nothing is downloaded before that press.
export default class extends Controller {
  static targets = [ "video", "cover" ]

  play() {
    this.coverTarget.hidden = true
    this.videoTarget.controls = true
    this.videoTarget.play()
  }

  // Back to the poster when it finishes, ready to play again.
  ended() {
    this.videoTarget.controls = false
    this.videoTarget.load()
    this.coverTarget.hidden = false
  }
}
